<h1 mat-dialog-title>Confirm Action</h1>
<div mat-dialog-content>
  
  <p>Are you sure you want to perform this action?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="true">Ok</button>
</div>
